import { useState, useEffect } from "react";

import API from "utils/api";
import { anyToHash } from "utils/misc";
import { useUser } from "utils/hooks";

export default function useDonations(filters) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDonations() {
      setLoading(true);
      const { response, data } = await API.fetchDonations(token, filters);

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    fetchDonations();
  }, [anyToHash(filters)]);

  return {
    loading,
    donations: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
